import React, { Component } from "react";

import {
  withGoogleMap,
  GoogleMap,
  withScriptjs,
  Marker,
} from "react-google-maps";

import "./LocationSearchModal.css";


/* =========================================================
   GOOGLE MAP
   נוצר פעם אחת בלבד ולא בכל render
========================================================= */

const AsyncMap = withScriptjs(
  withGoogleMap((props) => (

    <GoogleMap
      defaultZoom={props.zoom}

      defaultCenter={{
        lat: props.mapPosition.lat,
        lng: props.mapPosition.lng,
      }}

      options={{
        streetViewControl: false,
        mapTypeControl: false,
        fullscreenControl: true,
        zoomControl: true,
        gestureHandling: "greedy",
      }}
    >

      <Marker
        draggable={true}

        onDragEnd={props.onMarkerDragEnd}

        position={{
          lat: props.markerPosition.lat,
          lng: props.markerPosition.lng,
        }}

        title="נצר הובלות ומנופים בע״מ"
      />

    </GoogleMap>

  ))
);


class MapPage extends Component {

  state = {
    height: 400,

    zoom: 15,

    mapPosition: {
      lat: 31.86903,
      lng: 34.73979,
    },

    markerPosition: {
      lat: 31.86903,
      lng: 34.73979,
    },

    currentTime: new Date(),

    isOpen: false,

    timeRemaining: "",
  };


  /* =========================================================
     START TIMER
  ========================================================= */

  componentDidMount() {

    this.updateBusinessStatus();

    this.statusTimer = setInterval(
      this.updateBusinessStatus,
      1000
    );

  }


  /* =========================================================
     STOP TIMER
  ========================================================= */

  componentWillUnmount() {

    clearInterval(this.statusTimer);

  }


  /* =========================================================
     BUSINESS STATUS + COUNTDOWN
  ========================================================= */

  updateBusinessStatus = () => {

    const now = new Date();

    const hours = now.getHours();

    const minutes = now.getMinutes();

    const seconds = now.getSeconds();


    const currentSeconds =
      hours * 3600 +
      minutes * 60 +
      seconds;


    const openingSeconds =
      7 * 3600;


    const closingSeconds =
      17 * 3600;


    const isOpen =
      currentSeconds >= openingSeconds &&
      currentSeconds < closingSeconds;


    let remainingSeconds;


    if (isOpen) {

      // כמה זמן נשאר עד 17:00
      remainingSeconds =
        closingSeconds - currentSeconds;

    } else if (currentSeconds < openingSeconds) {

      // כמה זמן נשאר עד 07:00
      remainingSeconds =
        openingSeconds - currentSeconds;

    } else {

      // אחרי 17:00 - סופר עד 07:00 של מחר
      remainingSeconds =
        (24 * 3600 - currentSeconds) +
        openingSeconds;
    }


    const hoursLeft =
      Math.floor(
        remainingSeconds / 3600
      );


    const minutesLeft =
      Math.floor(
        (remainingSeconds % 3600) / 60
      );


    const secondsLeft =
      remainingSeconds % 60;


    const formattedTime =
      `${String(hoursLeft).padStart(2, "0")}:` +
      `${String(minutesLeft).padStart(2, "0")}:` +
      `${String(secondsLeft).padStart(2, "0")}`;


    this.setState({

      currentTime: now,

      isOpen,

      timeRemaining: formattedTime,

    });

  };


  /* =========================================================
     MARKER DRAG
  ========================================================= */

  onMarkerDragEnd = (event) => {

    const lat =
      event.latLng.lat();

    const lng =
      event.latLng.lng();


    this.setState({

      markerPosition: {
        lat,
        lng,
      },

    });

  };


  /* =========================================================
     RENDER
  ========================================================= */

  render() {

return (

  <section
    className="location-section"
    dir="rtl"
  >

    <div className="location-container">

      {/* =====================================================
          OFFICE TITLE
      ===================================================== */}

      <div className="office-title">

        <span className="office-title-line"></span>

        <h2>
          משרדנו
        </h2>

        <p>
          נצר הובלות ומנופים בע״מ
        </p>

        <span className="office-title-line"></span>

      </div>


      {/* =====================================================
          MAP CARD
      ===================================================== */}

      <div className="map-card">


            {/* TOP RED LINE */}

            <div className="map-top-line">
              <span></span>
            </div>


            {/* =================================================
                MAP
            ================================================= */}

            <div className="map-inner">

              <AsyncMap

                googleMapURL={
                  "https://maps.googleapis.com/maps/api/js?key=AIzaSyC2H55uGYHc55B2L3CwQd2Jzijoj_isaU0&libraries=places"
                }

                loadingElement={
                  <div
                    style={{
                      height: "100%",
                      width: "100%",
                      background: "#111",
                    }}
                  />
                }

                containerElement={
                  <div
                    style={{
                      height: this.state.height,
                      width: "100%",
                    }}
                  />
                }

                mapElement={
                  <div
                    style={{
                      height: "100%",
                      width: "100%",
                    }}
                  />
                }

                zoom={this.state.zoom}

                mapPosition={this.state.mapPosition}

                markerPosition={this.state.markerPosition}

                onMarkerDragEnd={
                  this.onMarkerDragEnd
                }

              />

            </div>


            {/* =================================================
                INFORMATION
            ================================================= */}

            <div className="map-info">


              {/* =================================================
                  COMPANY NAME
              ================================================= */}

              <div className="map-info-item">

        

                <div>
        <span className="map-icon">
                  🏢
                </span>
                  <small>
                    שם החברה
                  </small>

                  <strong>
                    נצר הובלות ומנופים בע"מ
                  </strong>

                </div>

              </div>


              {/* =================================================
                  BUSINESS HOURS
              ================================================= */}

              <div
                className="map-info-item"
                style={{
                  width: "100%",
                }}
              >

           


                <div
                  style={{
                    width: "100%",
                  }}
                >
     <span className="map-icon">
                  🕒
                </span>
                  <small>
                    שעות פעילות
                  </small>


                  <strong>
                    07:00 – 17:00
                  </strong>


                  {/* STATUS + COUNTDOWN */}

                  <div
                    style={{
                      marginTop: "8px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "18px",
                      flexWrap: "wrap",
                      width: "100%",
                    }}
                  >


                    {/* OPEN / CLOSED */}

                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "7px",
                        fontWeight: "700",
                        color: this.state.isOpen
                          ? "#16803c"
                          : "#d62828",
                      }}
                    >

                      <span
                        style={{
                          width: "10px",
                          height: "10px",
                          borderRadius: "50%",
                          background:
                            this.state.isOpen
                              ? "#16803c"
                              : "#d62828",

                          display: "inline-block",

                          boxShadow:
                            this.state.isOpen
                              ? "0 0 10px rgba(22,128,60,0.45)"
                              : "0 0 10px rgba(214,40,40,0.35)",
                        }}
                      />

                      {this.state.isOpen
                        ? "פתוח עכשיו"
                        : "סגור עכשיו"}

                    </span>


                    {/* COUNTDOWN */}

                    <span
                      style={{
                        fontWeight: "700",
                        letterSpacing: "1px",
                        direction: "ltr",
                        textAlign: "center",
                      }}
                    >

                      {this.state.isOpen
                        ? `נסגר בעוד ${this.state.timeRemaining}`
                        : `נפתח בעוד ${this.state.timeRemaining}`}

                    </span>

                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>

      </section>
    );
  }
}


export default MapPage;
